
define('text!views/shared/modal/modal_modern.html',[],function () { return '<div class="pf-modal-container">\r\n\t<div class="pf-modal-container-inner">\r\n\t\t<button id="pf-modal-close-btn"><%= enums.svg.mobileCloseMenuIcon %></button>\r\n\t\t<div class="pf-modal-content"><%= this.content %></div>\r\n\t</div>\r\n</div>';});

